import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-vista-previa-receta',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule, MatTooltipModule],
  templateUrl: './vista-previa-receta-dialog.html',
  styleUrl: './vista-previa-receta-dialog.scss',
})
export class VistaPreviaRecetaDialog implements OnDestroy {
  pdfUrl: SafeResourceUrl;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      pdfUrl: string;
    },

    private sanitizer: DomSanitizer,

    private dialogRef: MatDialogRef<VistaPreviaRecetaDialog>,
  ) {
    this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(data.pdfUrl);
  }

  cerrar(): void {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    if (this.data?.pdfUrl) {
      URL.revokeObjectURL(this.data.pdfUrl);
    }
  }
}
